import { useState } from 'react';
import { SignupField } from '../types/signup';

type Status = 'idle' | 'submitting' | 'success' | 'error';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function useSignupForm(fields: SignupField[]) {
  const [values, setValues] = useState<Record<string, string>>({});
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [status, setStatus] = useState<Status>('idle');

  const validate = () => {
    const next: Record<string, string> = {};
    fields.forEach((f) => {
      const v = (values[f.name] ?? '').trim();
      if (f.required && !v) next[f.name] = 'Required';
      else if (f.type === 'email' && v && !EMAIL_RE.test(v)) next[f.name] = 'Enter a valid email';
    });
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleChange = (name: string, value: string) => {
    setValues((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    setStatus('submitting');
    try {
      // Replace with a real request (e.g. Formspree, Supabase) when the backend is ready.
      await new Promise((resolve) => setTimeout(resolve, 900));
      setStatus('success');
    } catch {
      setStatus('error');
    }
  };

  const reset = () => {
    setValues({});
    setErrors({});
    setStatus('idle');
  };

  return { values, errors, status, handleChange, handleSubmit, reset };
}
